import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { DocumentTemplateService } from "../../../../services/document/document-template.service";

export const useDocumentTemplate = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["document-template"],
    queryFn: () => DocumentTemplateService.getList(),
  });

  const activeData = useMemo(() => data?.filter((e: any) => e.IsActive), [data]);

  return { data, isLoading, activeData };
};
